export default __webpack_public_path__ + "static/media/3611b254cdde2e35b3ef29ca5985292d.svg";